import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailSearchType, DetailSearchValidationConfig, getDetailSearchConfig } from '../utils/detailSearchConfig'
import { useDetailSearchFormValues } from './useDetailSearchFormValues'

export const useDetailSearch = (type: DetailSearchType, data: Record<string, unknown> | null) => {
    const { t } = useTranslation()

    const config = getDetailSearchConfig(type)

    const title = t(config.titleKey)
    const subtitle = config.subtitleKey ? t(config.subtitleKey) : ''
    const redirectPage = config.redirectPage

    const inputs = useMemo(() => config.getInputs(), [config])
    const profileInputs = useMemo(() => config.getProfileInputs?.() ?? null, [config])

    const validationConfig: DetailSearchValidationConfig = useMemo(() => config.getValidation(data), [config, data])
    const profileValidationConfig: DetailSearchValidationConfig | null = useMemo(() => config.getProfileValidation?.(data) ?? null, [config, data])

    const { selectOptions, profileSelectOptions, isPending: selectOptionsLoading } = useDetailSearchFormValues(type, t)

    return {
        config,
        title,
        subtitle,
        inputs,
        profileInputs,
        validationConfig,
        profileValidationConfig,
        selectOptions,
        profileSelectOptions,
        selectOptionsLoading,
        redirectPage,
    }
}
